import { render, staticRenderFns } from "./NoteReminderDialog.vue?vue&type=template&id=74073018&scoped=true"
import script from "./NoteReminderDialog.vue?vue&type=script&lang=js"
export * from "./NoteReminderDialog.vue?vue&type=script&lang=js"
import style0 from "./NoteReminderDialog.vue?vue&type=style&index=0&id=74073018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74073018",
  null
  
)

export default component.exports